/**
 * Authentication Provider - Admin Console
 * 
 * Thin re-export layer over @vanguard-atlas/shared auth.
 * All auth logic lives in the shared package to avoid duplication
 * between admin-console and agent-ui.
 * 
 * Local exports: identityClient, IDENTITY_API_URL, IDENTITY_BROWSER_URL
 * (used by LoginPage and ErrorPage for direct identity flows)
 */

import { FrontendApi, Configuration } from '@ory/client';
import { AUTH_URL, AUTH_BROWSER_URL } from './config';

// =============================================================================
// Re-export shared auth (AuthProvider, hooks, types)
// =============================================================================

export {
  AuthProvider,
  useAuth,
  useUser,
  useHasRole,
  useHasAnyRole,
} from 'shared/hooks/useAuth';

export type {
  AuthContextValue,
  AuthState,
  AuthenticatorAssuranceLevel,
  User,
} from 'shared/types/auth';

export type { AuthProviderProps } from 'shared/hooks/useAuth';

// =============================================================================
// Local Ory Client (for LoginPage, ErrorPage direct Kratos flows)
// =============================================================================

const IDENTITY_API_URL = AUTH_URL;
const IDENTITY_BROWSER_URL = AUTH_BROWSER_URL;

const identityClient = new FrontendApi(
  new Configuration({
    basePath: IDENTITY_API_URL,
    baseOptions: {
      withCredentials: true,
    },
  })
);

export const oryBrowserFlowOptions = {
  validateStatus: (status: number) =>
    (status >= 200 && status < 300) || status === 422,
};

export { identityClient, IDENTITY_API_URL, IDENTITY_BROWSER_URL };

